import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IsLoadingService extends BehaviorSubject<boolean> {
  private count = 0;
  constructor() {
    super(false);
  }

  start() {
    this.count++;
    this.next(true);
  }

  stop() {
    this.count--;
    if (this.count < 1) {
      this.count = 0;
      this.next(false);
    }
  }
}
